<div class="flex-column" fusePerfectScrollbar>
  <img src="assets/images/rassegna/1.png" />
  <img src="assets/images/rassegna/2.png" />
  <img src="assets/images/rassegna/3.png" />
</div>
